import { ref, onMounted, onUnmounted } from 'vue'
import type { Ref } from 'vue'

type DeviceType = 'mobile' | 'desktop'

interface DeviceDetector {
  isMobile: Ref<boolean>
  deviceType: Ref<DeviceType>
  checkDevice: () => void
}

export function deviceDetector(): DeviceDetector {
  const isMobile = ref(false)
  const deviceType = ref<DeviceType>('desktop')

  const checkDevice = (): void => {
    // 方法1：通过用户代理检测
    const userAgent = navigator.userAgent.toLowerCase()
    const isMobileUA =
      /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent
      )

    // 方法2：通过屏幕尺寸检测
    const isSmallScreen = window.innerWidth < 768

    // 综合判断
    isMobile.value = isMobileUA || isSmallScreen
    deviceType.value = isMobile.value ? 'mobile' : 'desktop'
  }

  const handleResize = (): void => {
    checkDevice()
  }

  onMounted(() => {
    checkDevice()
    window.addEventListener('resize', handleResize)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
  })

  return {
    isMobile,
    deviceType,
    checkDevice,
  }
}
